export const stringToBooleanMapper = { true: true, false: false };

export const stringToBooleanTranslateMapper = { true: 'buttons.yes', false: 'buttons.no' };
